import angular from 'angular';

export const autoFocus = ($timeout, $parse) => ({
    link($scope, $element, attrs) {
        const model = $parse(attrs.autoFocus);
        $scope.$watch(model, (value) => {
            if (value === true) {
                $timeout(() => {
                    $element.focus();
                }, 100);
            }
        });
    },
});

export const arrowSelector = ($document, $parse) => ({
    link(scope, $element, attrs) {
        const model = $parse(attrs.arrowSelector);
        scope.$watch(model, (value) => {
            if (value === true) {
                $document.off('keydown');
                $document.on('keydown', (e) => {
                    e.stopImmediatePropagation();
                    // Enter
                    if (e.keyCode === 13) {
                        if (scope.dynamicCriteriaCtrl) {
                            if (scope.dynamicCriteriaCtrl.focusedOn < 0 ||
                                scope.dynamicCriteriaCtrl.focusedOn >= scope.dynamicCriteriaCtrl.dynamicFilteredData.values.length) {
                                scope.dynamicCriteriaCtrl.filterValueChosen({ text: scope.dynamicCriteriaCtrl.filterValues });
                            } else {
                                scope.dynamicCriteriaCtrl.filterValueChosen(
                                    scope.dynamicCriteriaCtrl.dynamicFilteredData.values[scope.dynamicCriteriaCtrl.focusedOn]
                                );
                            }
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.dynamicCriteriaWithGroupsCtrl) {
                            if (scope.dynamicCriteriaWithGroupsCtrl.focusedOn < 0 ||
                                // eslint-disable-next-line max-len
                                scope.dynamicCriteriaWithGroupsCtrl.focusedOn >= scope.dynamicCriteriaWithGroupsCtrl.dynamicFilteredData.values.length) {
                                scope.dynamicCriteriaWithGroupsCtrl.filterValueChosen({ text: scope.dynamicCriteriaWithGroupsCtrl.filterValues });
                            } else {
                                scope.dynamicCriteriaWithGroupsCtrl.filterValueChosen(
                                    scope.dynamicCriteriaWithGroupsCtrl.dynamicFilteredData.values[scope.dynamicCriteriaWithGroupsCtrl.focusedOn]
                                );
                            }
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.staticCriteriaCtrl) {
                            scope.staticCriteriaCtrl.staticChosen(scope.staticCriteriaCtrl.filteredStaticData[scope.staticCriteriaCtrl.focusedOn]);
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.createJobCtrl) {
                            if (scope.createJobCtrl.functionalRoleFocusedOn >= 0) {
                                const filteredRole = scope.createJobCtrl.filteredFunctionalRoles[scope.createJobCtrl.functionalRoleFocusedOn];
                                if (filteredRole){
                                    scope.createJobCtrl.newPosition.functionalRole = filteredRole.text;
                                }
                                scope.createJobCtrl.functionalRoleDropDownShowen = false;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.jobTitlefocusedOn >= 0) {
                                scope.createJobCtrl.newPosition.jobTitle =
                                    scope.createJobCtrl.jobTitleFilteredData.values[scope.createJobCtrl.jobTitlefocusedOn].value;
                                scope.createJobCtrl.jobTitleShowDropDown = false;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.placementFeeUnitFocusedOn >= 0) {
                                scope.createJobCtrl.newPosition.placementFee.unit =
                                    scope.createJobCtrl.filteredPlacementFreeUnit[scope.createJobCtrl.placementFeeUnitFocusedOn];
                                scope.createJobCtrl.placementFeeUnitDropDownShowen = false;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.createEmpCtrl) {
                            if (scope.createEmpCtrl.cityFocusedOn >= 0) {
                                scope.createEmpCtrl.employerData.locations[scope.createEmpCtrl.currentCityIndex].city =
                                    scope.createEmpCtrl.filteredCity[scope.createEmpCtrl.cityFocusedOn];
                                scope.createEmpCtrl.employerData.locations[scope.createEmpCtrl.currentCityIndex].showDropDownCity = false;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.emailSelectionCtrl) {
                            if (scope.emailSelectionCtrl.focusedOn >= 0) {
                                scope.emailSelectionCtrl.addEmailToSelected(scope.emailSelectionCtrl.focusedOn);
                                scope.$apply();
                                e.preventDefault();
                            }
                        }
                    }
                    // key arrow up
                    if (e.keyCode == 38) {

                        if (scope.dynamicCriteriaCtrl) {
                            if (scope.dynamicCriteriaCtrl.focusedOn == -1) {
                                return;
                            }
                            scope.dynamicCriteriaCtrl.focusedOn--;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.dynamicCriteriaWithGroupsCtrl ) {
                            if (scope.dynamicCriteriaWithGroupsCtrl.focusedOn == -1) {
                                return;
                            }
                            scope.dynamicCriteriaWithGroupsCtrl.focusedOn--;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.staticCriteriaCtrl) {
                            if (scope.staticCriteriaCtrl.focusedOn == -1) {
                                return;
                            }
                            scope.staticCriteriaCtrl.focusedOn--;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.createJobCtrl) {
                            if (scope.createJobCtrl.functionalRoleFocusedOn >= 0) {
                                if (scope.createJobCtrl.functionalRoleFocusedOn == 0) {
                                    return;
                                }
                                scope.createJobCtrl.functionalRoleFocusedOn--;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.jobTitlefocusedOn >= 0) {
                                if (scope.createJobCtrl.jobTitlefocusedOn == 0) {
                                    return;
                                }
                                scope.createJobCtrl.jobTitlefocusedOn--;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.placementFeeUnitFocusedOn >= 0) {
                                if (scope.createJobCtrl.placementFeeUnitFocusedOn == 0) {
                                    return;
                                }
                                scope.createJobCtrl.placementFeeUnitFocusedOn--;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.createEmpCtrl) {
                            if (scope.createEmpCtrl.cityFocusedOn >= 0) {
                                if (scope.createEmpCtrl.cityFocusedOn == 0) {
                                    return;
                                }
                                scope.createEmpCtrl.cityFocusedOn--;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.emailSelectionCtrl) {
                            if (scope.emailSelectionCtrl.focusedOn >= 0) {
                                if (scope.emailSelectionCtrl.focusedOn == 0) {
                                    return;
                                }
                                scope.emailSelectionCtrl.focusedOn--;
                                scope.$apply();
                                e.preventDefault();
                            }
                        }
                    }
                    // key arrow down
                    if (e.keyCode == 40) {
                        if (scope.dynamicCriteriaCtrl) {
                            if (scope.dynamicCriteriaCtrl.focusedOn == scope.dynamicCriteriaCtrl.dynamicFilteredData.values.length) {
                                return;
                            }
                            scope.dynamicCriteriaCtrl.focusedOn++;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.dynamicCriteriaWithGroupsCtrl) {
                            // eslint-disable-next-line max-len
                            if (scope.dynamicCriteriaWithGroupsCtrl.focusedOn == scope.dynamicCriteriaWithGroupsCtrl.dynamicFilteredData.values.length) {
                                return;
                            }
                            scope.dynamicCriteriaWithGroupsCtrl.focusedOn++;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.staticCriteriaCtrl) {
                            if (scope.staticCriteriaCtrl.focusedOn == scope.staticCriteriaCtrl.filteredStaticData.length) {
                                return;
                            }
                            scope.staticCriteriaCtrl.focusedOn++;
                            scope.$apply();
                            e.preventDefault();
                        } else if (scope.createJobCtrl) {
                            if (scope.createJobCtrl.functionalRoleFocusedOn >= 0) {
                                if (scope.createJobCtrl.functionalRoleFocusedOn == scope.createJobCtrl.filteredFunctionalRoles.length) {
                                    return;
                                }
                                scope.createJobCtrl.functionalRoleFocusedOn++;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.jobTitlefocusedOn >= 0) {
                                if (scope.createJobCtrl.jobTitlefocusedOn == scope.createJobCtrl.jobTitleFilteredData.values.length) {
                                    return;
                                }
                                scope.createJobCtrl.jobTitlefocusedOn++;
                                scope.$apply();
                                e.preventDefault();
                            } else if (scope.createJobCtrl.placementFeeUnitFocusedOn >= 0) {
                                if (scope.createJobCtrl.placementFeeUnitFocusedOn == scope.createJobCtrl.filteredPlacementFreeUnit.length) {
                                    return;
                                }
                                scope.createJobCtrl.placementFeeUnitFocusedOn++;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.createEmpCtrl) {
                            if (scope.createEmpCtrl.cityFocusedOn >= 0) {
                                if (scope.createEmpCtrl.cityFocusedOn == scope.createEmpCtrl.filteredCity.length) {
                                    return;
                                }
                                scope.createEmpCtrl.cityFocusedOn++;
                                scope.$apply();
                                e.preventDefault();
                            }
                        } else if (scope.emailSelectionCtrl) {
                            if (scope.emailSelectionCtrl.focusedOn >= 0) {
                                if (scope.emailSelectionCtrl.focusedOn == scope.emailSelectionCtrl.filteredEmailsData.length - 1) {
                                    return;
                                }
                                scope.emailSelectionCtrl.focusedOn++;
                                scope.$apply();
                                e.preventDefault();
                            }
                        }
                    }
                });
            } else {
                $document.off('keydown');
            }
        });
        scope.$on('$destroy', () => {
            $document.off('keydown');
        });
    },
});

angular.module('TALENYA-FE')
    .directive('autoFocus', autoFocus)
    .directive('arrowSelector', arrowSelector);
